import Geocoder from "ol-geocoder";

export function addGeocoderControl(map) {
  const geocoder = new Geocoder("nominatim", {
    provider: "osm",
    lang: "en",
    targetType: "glass-button",
    placeholder: "Search for ...",
    limit: 5,
    debug: false,
    autoComplete: true,
    keepOpen: false,
    preventMarker: true,
  });
  map.addControl(geocoder);
}
